import { Checkbox, FormControlLabel, Grid, InputAdornment, Paper, TextField } from '@material-ui/core'
import { DateTimePicker } from '@material-ui/pickers'
import { Moment } from 'moment';
import React, { useEffect, useState } from 'react'
import { useStressEntryContext } from './StressEntryContext';
import { STRESSOR_CHECK_IN_MODE, STRESSOR_CHECK_OUT_MODE } from './constants';

export const HumidityFreezeFields = () => {

    const [formData, setFormData] = useState({
        Calibration_date: null as Moment | null,
        Test_temperature: "",
        Test_humidity: "",
        Applied_current: "",
        Voltage_is_normal: false,
        Number_of_TestCycles: ""
    });

    const [errors, setErrors] = useState<{ [key: string]: string }>({});

    const { state, dispatch } = useStressEntryContext();

    const handleDateChange = (date: Moment | null) => {
        setFormData(prev => ({ ...prev, Calibration_date: date }));
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;

        // For Test_temperature field
        if (name === "Test_temperature") {
            const temp = parseFloat(value);
            if (isNaN(temp) || temp < -40 || temp > 85) {
                setErrors((prev) => ({
                    ...prev,
                    Test_temperature: "Value must be between -40°C and 85°C",
                }));
            } else {
                setErrors((prev) => ({
                    ...prev,
                    Test_temperature: "",
                }));
            }
        }

        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };


    const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, checked } = e.target;
        setFormData(prev => ({ ...prev, [name]: checked }))
    }

    useEffect(() => {
        const payload = {
            Calibration_date: formData.Calibration_date
                ? formData.Calibration_date.format("YYYY-MM-DD")
                : "",
            Test_temperature: formData.Test_temperature ? formData.Test_temperature : null,
            Test_humidity: formData.Test_humidity ? parseFloat(formData.Test_humidity) : null,
            Applied_current: formData.Applied_current ? parseFloat(formData.Applied_current) : null,
            Voltage_is_normal: formData.Voltage_is_normal,
            Number_of_TestCycles: formData.Number_of_TestCycles ? parseFloat(formData.Number_of_TestCycles) : null

        };
        console.log("Auto-updated payload:", payload);
        dispatch({ type: "HF_STRESS_DETAILS", payload });
    }, [formData, dispatch]);

    return (
        <div>

            {state.mode === STRESSOR_CHECK_OUT_MODE && state.isHumidityTestCheck && (
                <Paper elevation={3} style={{ padding: 10, marginBottom: 16 }}>
                    <Grid
                        container
                        direction="row"
                        justifyContent="space-around"
                        alignItems="flex-start"
                        spacing={2}
                        style={{ marginTop: 16, marginBottom: 16 }}
                    >
                        <Grid item xs={6}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} style={{ marginTop: 18 }}>
                                    <DateTimePicker
                                        label="Calibration Date"
                                        format="YYYY-MM-DD HH:mm"
                                        fullWidth
                                        value={formData.Calibration_date}
                                        onChange={handleDateChange}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField

                                        name="Test_temperature"
                                        label="Test Temperature"
                                        type="string"
                                        value={formData.Test_temperature}
                                        onChange={handleChange}
                                        fullWidth
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">°C</InputAdornment>
                                            ),
                                        }}
                                        error={!!errors.Test_temperature}
                                        helperText={errors.Test_temperature}
                                    />

                                </Grid>
                                <Grid item xs={12}>
                                    <TextField

                                        name="Test_humidity"
                                        label="Test Humidity"
                                        type="number"
                                        value={formData.Test_humidity}
                                        onChange={handleChange}
                                        fullWidth
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">%RH</InputAdornment>
                                            ),
                                        }}
                                    />
                                </Grid>
                                {/* <Grid item xs={12}>
                                    <TextField

                                        name="Applied_current"
                                        label="Applied current (Low)"
                                        type="number"
                                        value={formData.Applied_current}
                                        onChange={handleChange}
                                        fullWidth
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">A</InputAdornment>
                                            ),
                                        }}
                                    />

                                </Grid> */}
                                <Grid item xs={12}>

                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                name="Voltage_is_normal"
                                                checked={formData.Voltage_is_normal}
                                                onChange={handleCheckboxChange}
                                            />
                                        }
                                        label="Current and Voltage is normal"
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        name='Number_of_TestCycles'
                                        label='Number of TestCycles'
                                        type="number"
                                        value={formData.Number_of_TestCycles}
                                        onChange={handleChange}
                                        fullWidth
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Paper>
            )}
        </div>
    )
}


